export default __webpack_public_path__ + "static/media/wi_4.c46ae2e2.mp3";